import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const LensStatusContainer = styled.div<{ width?: string }>`
    display: flex;
    align-items: center;
    width: ${({ width = "60%" }) => width};
    height: 44px;
`;

export const iconSpacing = css`
    margin-right: ${Spacing.MD}px;
`;

export const Circle = styled.span<{ color: string; borderColor: string }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 28px;
    height: 28px;

    background-color: ${(props) => props.color};
    border: 2px solid ${(props) => props.borderColor};
    border-radius: 50%;

    .sds-icon-error {
        path:nth-child(2),
        path:nth-child(3) {
            fill: ${(props) => props.borderColor}!important;
        }
    }
`;

export const LensStatusTitle = styled.h3`
    ${Fonts.Heading.H400};
    margin-bottom: 0;
`;

export const LensStatusTagline = styled.p`
    ${Fonts.SubHeading.SH400};
    margin-bottom: 0;
    color: ${Colors.Black.V50};
`;

export const chevronButton = css`
    position: relative;
    top: 2px;
`;

export const WarningSectionWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    margin-right: ${Spacing["2XS"]}px;
    margin-left: ${Spacing["2XS"]}px;
`;
